import React, { useEffect, useState } from 'react';
import { SignIn, SignUp } from '@clerk/clerk-react';
import { Link } from 'react-router-dom';
import { useTheme } from '../context/ThemeContext';
import { Icon } from './ui/FieldNotes';
import lightBrandMark from '../assets/namecamper-mark-light.svg';
import darkBrandMark from '../assets/namecamper-mark-dark.svg';
import './Auth.css';

function isInAppBrowser() {
  const ua = navigator.userAgent || navigator.vendor || '';
  return /FBAN|FBAV|FB_IAB|Instagram|Twitter|LinkedIn|Slack|Discord|Snapchat|Pinterest|TikTok|Telegram/i.test(ua)
    || (ua.includes('wv') && ua.includes('Android')) || ua.includes('WebView')
    || (window.navigator.standalone === false && /iPhone|iPad|iPod/.test(ua));
}
export default function AuthScreen({ register = false }) {
  const { resolvedTheme } = useTheme();
  const [webView, setWebView] = useState(false);
  useEffect(() => setWebView(isInAppBrowser()), []);
  const dark = resolvedTheme === 'dark';
  const appearance = {
    layout: { logoImageUrl: dark ? darkBrandMark : lightBrandMark },
    variables: {
      colorPrimary: dark ? '#b8d3a8' : '#28543f',
      colorTextOnPrimaryBackground: dark ? '#172a1d' : '#fffef8',
      colorBackground: dark ? '#1c2921' : '#fffef8',
      colorText: dark ? '#f0eee2' : '#28382e',
      colorTextSecondary: dark ? '#b3bdae' : '#62695d',
      colorInputBackground: dark ? '#141e19' : '#fffef8',
      colorInputText: dark ? '#f0eee2' : '#28382e',
      colorNeutral: dark ? '#f0eee2' : '#28382e',
      borderRadius: '0.5rem',
      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
    },
    elements: {
      rootBox: { width: '100%', maxWidth: '100%' },
      cardBox: { width: '100%', maxWidth: '100%', boxShadow: 'none' },
      card: { width: '100%', maxWidth: '100%', boxShadow: 'none', padding: '24px' },
      headerTitle: { fontFamily: 'Georgia, serif', fontSize: '26px', fontWeight: '400' },
      formButtonPrimary: { minHeight: '44px', textTransform: 'none' },
      socialButtonsBlockButton: { minHeight: '44px' },
      formFieldInput: { minHeight: '44px' },
    },
  };
  return <div className="auth-layout">
    <div className="auth-intro"><span className="auth-emblem"><Icon name="tent" size={34} /></span><p className="eyebrow">YOUR NEXT GOOD NAME</p>
      <h1>{register ? 'Set up camp.' : 'Welcome back.'}</h1><p>{register ? 'Start a watchlist for the handles and domains you have your eye on.' : 'Your names are right where you left them.'}</p>
      <Link to="/" className="text-link">← Back to NameCamper</Link>
    </div>
    <div className="auth-container">
      {webView && <aside className="webview-warning"><strong>Signing in from another app?</strong><p>Google sign-in may need your regular browser. Use “Open in browser” from the app menu, or copy this page’s address into Chrome, Safari, or Firefox.</p></aside>}
      <div className="auth-card">{register
        ? <SignUp routing="path" path="/register" signInUrl="/login" afterSignUpUrl="/dashboard" appearance={appearance} />
        : <SignIn routing="path" path="/login" signUpUrl="/register" afterSignInUrl="/dashboard" appearance={appearance} />}
      </div>
      <p className="auth-footnote">Free beta access. No payment details required.</p>
    </div>
  </div>;
}
